
export const StripePriceIDMap = {
    STARTUP_PLAN_ID      : "price_1K3Br4AOn0O3FLm4m843fNA0",  // $110
    BUSINESS_BUILDER_ID  : "price_1K3BoiAOn0O3FLm4ijoA9YOO",  // $149
    CORPORATE_PRICE_ID   : "price_1Jz889AOn0O3FLm4WREwHIFi"   // $189
}

export const defaultPlan = "BUSINESS_BUILDER_ID" ;

// old price ids
// export const StripePriceIDMap = {
//     STARTUP_PLAN_ID      : "price_1JSQhHAOn0O3FLm4hBTgSDIA", 
//     BUSINESS_BUILDER_ID : "price_1JSQhtAOn0O3FLm4Ka0GQTDg",  
//     CORPORATE_PRICE_ID   : "price_1JSQiXAOn0O3FLm4cOQGuGB4"  
// }